import React, { useContext } from 'react'
import Div from '@jarvis.oddle/core/components/Div'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { useRouter } from 'next/router'
import InlineTextLink from 'src/components/core/InlineTextLink'

import { CheckBox } from './Elements'

interface AgreementProps {
  receiveEmail: boolean
}

const Agreement = ({ receiveEmail }: AgreementProps): JSX.Element => {
  const router = useRouter()
  const { t } = useContext(TranslationContext)
  return (
    <React.Fragment>
      <Div>
        <CheckBox
          name='termsAndConditionsCheckbox'
          content={t(
            'I accept the _termsAndConditionsLink_ and _privacyPolicyLink_',
            {
              termsAndConditionsLink: <InlineTextLink
                path='/[locale]/terms'
                pathAs={`/${router.query.locale}/terms`}
                text={t('Terms & Conditions')}
                target='_blank'
              />,
              privacyPolicyLink: <InlineTextLink
                path='/[locale]/privacy'
                pathAs={`/${router.query.locale}/privacy`}
                text={t('Privacy Policy')}
                target='_blank'
              />
            }
          )}
        />
      </Div>
      {!receiveEmail && (
        <Div width='100%' marginBottom={marginSizes.small}>
          <CheckBox
            name='newsletterCheckbox'
            content={t('Update me on the occasional offers')}
          />
        </Div>
      )}
    </React.Fragment>
  )
}

export default Agreement
